import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useNotifications } from "@/hooks/useNotifications";
import { NotificationItem } from "./NotificationItem";

/** ベルクリック時のドロップダウン（最新5件 + 全て見るリンク） */
export function NotificationDropdown() {
  const navigate = useNavigate();
  const {
    notifications,
    unreadCount,
    isLoading,
    markRead,
    markAllRead,
    isMarkingAllRead,
  } = useNotifications({ limit: 5 });

  return (
    <div className="flex flex-col">
      {/* ヘッダー */}
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <span className="text-sm font-semibold">
          お知らせ
          {unreadCount > 0 && (
            <span className="ml-1 text-muted-foreground font-normal">
              ({unreadCount}件未読)
            </span>
          )}
        </span>
        {unreadCount > 0 && (
          <Button
            variant="ghost"
            size="sm"
            className="text-xs h-7"
            onClick={() => markAllRead()}
            disabled={isMarkingAllRead}
            aria-label="全て既読にする"
          >
            {isMarkingAllRead ? (
              <Loader2 className="h-3 w-3 animate-spin" aria-hidden="true" />
            ) : (
              "全て既読"
            )}
          </Button>
        )}
      </div>

      {/* 通知リスト */}
      <ScrollArea className="max-h-80">
        {isLoading ? (
          <div className="flex items-center justify-center py-6">
            <Loader2
              className="h-5 w-5 animate-spin text-muted-foreground"
              aria-label="読み込み中"
            />
          </div>
        ) : notifications.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-6 px-4">
            お知らせはありません
          </p>
        ) : (
          <div role="list" aria-label="お知らせ一覧">
            {notifications.map((notification) => (
              <div key={notification.id} role="listitem">
                <NotificationItem
                  notification={notification}
                  onMarkRead={(id) => markRead(id)}
                />
              </div>
            ))}
          </div>
        )}
      </ScrollArea>

      {/* フッター */}
      <div className="border-t px-4 py-2">
        <Button
          variant="ghost"
          size="sm"
          className="w-full text-xs text-muted-foreground hover:text-foreground"
          onClick={() => navigate("/student/notifications")}
          aria-label="すべてのお知らせを見る"
        >
          すべて見る
        </Button>
      </div>
    </div>
  );
}
